































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import EstimatePurchaseRow from "./EstimatePurchaseRow.vue";
import VTh from "./VTh.vue";

@Component({
  components: {
    VTh,
    EstimatePurchaseRow
  }
})
export default class PurchaseOptionHeader extends Vue {
  @Prop({ required: true }) isCheckAllRow!: boolean;

  isChecked: boolean = false;

  created() {
    this.initIsChecked();
  }

  @Watch("isCheckAllRow")
  initIsChecked() {
    this.isChecked = this.isCheckAllRow;
  }

  handleCheckBox(isChecked: boolean) {
    this.$emit("checkAllRow", isChecked);
  }
}
